import { EndpointOptions } from '@/types/endpoint.options';
import { BrandGroupEntity } from '@/entities/brand-group.entity';
import {
    GroupCsvDownloadResult,
    GroupExtractResponse,
    GroupMergePayload,
    GroupRenamePayload,
    GroupRenameResponse,
} from '@/repositories/group-mutation-repository-handlers';
import { MarketplaceGroupRepositoryBase } from '@/repositories/marketplace-group.repository.base';

type BrandGroupDetailsBrandEntity = {
    name: string;
    productGroupCount: number;
    productCount: number;
};

type BrandGroupDetailsResponse = {
    id: string;
    name: string;
    brands: BrandGroupDetailsBrandEntity[];
};

type ExtractBrandsFromGroupPayload = {
    brandNames: string[];
};

type DownloadBrandsCsvQuery = {
    brandGroupIds?: string[];
    exportOperationId?: string;
};

class MarketplaceBrandsRepository extends MarketplaceGroupRepositoryBase<
    BrandGroupEntity[],
    BrandGroupDetailsResponse,
    GroupRenameResponse,
    ExtractBrandsFromGroupPayload,
    GroupExtractResponse,
    DownloadBrandsCsvQuery
> {
    constructor() {
        super({
            resourcePath: 'brands',
            csvFileName: 'brand-groups.csv',
        });
    }

    getBrandGroups(options?: EndpointOptions) {
        return this.getList(options);
    }

    mergeBrandGroups(data: GroupMergePayload, options?: EndpointOptions) {
        return this.mergeGroups(data, options);
    }

    getBrandGroup(groupId: string, options?: EndpointOptions) {
        return this.getGroup(groupId, options);
    }

    renameBrandGroup(groupId: string, data: GroupRenamePayload, options?: EndpointOptions) {
        return this.renameGroup(groupId, data, options);
    }

    extractBrandsFromGroup(groupId: string, data: ExtractBrandsFromGroupPayload, options?: EndpointOptions) {
        return this.extractFromGroup(groupId, data, options);
    }

    async downloadCsv(query: DownloadBrandsCsvQuery, options?: EndpointOptions): Promise<GroupCsvDownloadResult> {
        return super.downloadCsv(query, options);
    }
}

export const createMarketplaceBrandsRepository = () => new MarketplaceBrandsRepository();

export const marketplaceBrandsRepository = createMarketplaceBrandsRepository();
